import { render, staticRenderFns } from "./ModulePermissionsAccess.vue?vue&type=template&id=564b792e&scoped=true"
import script from "./ModulePermissionsAccess.vue?vue&type=script&lang=js"
export * from "./ModulePermissionsAccess.vue?vue&type=script&lang=js"
import style0 from "./ModulePermissionsAccess.vue?vue&type=style&index=0&id=564b792e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564b792e",
  null
  
)

export default component.exports